/**
 * One imperative way to say "this action needs a signed-in person" (UAT L2). `SignInPrompt`
 * registers the opener on mount; any screen calls `promptSignIn(next)` BEFORE the network call, so
 * a guest sees the same modal everywhere — with a return path — instead of a different outcome per
 * screen (a redirect here, a POST-then-401 modal there). The 401 interceptor stays as the last
 * resort for a screen that forgot.
 */
let opener = null;

export function onSignInPrompt(fn) {
  opener = fn;
}

/** Opens the modal. Returns false when no `SignInPrompt` is mounted (nothing was shown). */
export function promptSignIn(next) {
  if (!opener) return false;
  opener(next);
  return true;
}
